import axios from 'axios';
/**
 * CONTROLADOR API - MANEJO DE PETICIONES HTTP
 * @param {string} baseUrl - URL ENDPOINT PRINCIPAL DE LA API
 */
export default class ApiController {
  constructor(baseUrl) {
    this.baseUrl = baseUrl;
    this.axiosInstance = axios.create({
      baseURL: baseUrl,
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true
    });
  }
  //METODO GET
  async get(endpoint) {
    try {
      const response = await this.axiosInstance.get(endpoint);
      return response.data;
    } catch (error) {
      return this.handleError(error);
    }
  }

  // Método POST para login (no se necesita token en headers)
async postLogin(endpoint, data) {
  try {
    const response = await this.axiosInstance.post(endpoint, data, {
      withCredentials: true
    });
    return response.data;
  } catch (error) {
      return this.handleError(error);
    }
}
  // Método POST PARA FORMDATA para otras solicitudes autenticadas
async postFormData(endpoint, formData) {
  try {
    const response = await axios.post(this.baseUrl + endpoint, formData, {
      withCredentials: true
    });
    return response.data;
  } catch (error) {
    return this.handleError(error);
  }
}

  // Método POST para otras solicitudes autenticadas
  async post(endpoint, data) {
    try {
      const response = await this.axiosInstance.post(endpoint, data);
      return response.data;
    } catch (error) {
      return this.handleError(error);
    }
  }

  // Método PUT
  async put(endpoint, data) {
    try {
      const response = await this.axiosInstance.put(endpoint, data);
      return response.data;
    } catch (error) {
      return this.handleError(error);
    }
  }

  // Método DELETE
  async delete(endpoint) {
    try {
      const response = await this.axiosInstance.delete(endpoint);
      return response.data;
    } catch (error) {
      return this.handleError(error);
    }
  }

async downloadPDFWithIDs(endpoint, ids, fileName = 'NOPALA DE VILLAGRÁN - SISTEMA DE INVENTARIOS MUNICIPAL (QR INVENTARIOS).pdf') {
  try {
    const response = await this.axiosInstance.post(endpoint, { ids }, {
      responseType: 'blob', // importante para recibir PDF
      withCredentials: true
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();

    return { success: true, message:'DOWNLOAD SUCCESS' };
  } catch (error) {
    return this.handleError(error);
  }
  }

  async downloadPDFById(endpoint, fileName = null) {
  try {
    fileName = fileName
      ? `VALE_DE_RESGUARDO_${fileName}.pdf`
      : 'VALE_DE_RESGUARDO.pdf';
      
    const response = await this.axiosInstance.get(endpoint, {
      responseType: 'blob',
      withCredentials: true
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();

    return { success: true, message: 'DOWNLOAD SUCCESS' };
  } catch (error) {
    return this.handleError(error);
  }
}
//MANEJO DE ERRORES
  handleError(error) {
    if (error.response) {
      //! El servidor respondió con error HTTP (401, 403, 500...)
      return {
        ...error.response.data,
        message: error.response.data?.message || 'Error del servidor',
        status: error.response.status
      };
    } else if (error.request) {
      //! No hubo respuesta del servidor
      return {
        success: false,
        message: 'No hay respuesta del servidor',
        status: null
      };
    } else {
      //! Otros errores (JS, configuración Axios, etc.)
      return {
        success: false,
        message: error.message,
        status: null
      };
    }
  }
}